import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import DaDreamupLogoAndTextColoredAndBranded from '@wix/da-ds/pkg/DaDreamupLogoAndTextColored';
import LoadableIngressForm from '@wix/da-dreamup/pkg/components/LoadableIngressForm';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import PlaygroundEmptyStateDesktop from '../../PlaygroundEmptyStateDesktop';
import PlaygroundEmptyStateMobile from '../../PlaygroundEmptyStateMobile';

import s from './DreamupEmptyState.scss';

interface Props {}

const DreamupEmptyState: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  return isMobile ? (
    <PlaygroundEmptyStateMobile
      heading={t('playground.emptyState.dreamup.heading.mobile', {
        postProcess: ['reactPostprocessor'],
        alt: (
          <VisuallyHidden>{t('playground.emptyState.dreamup.heading.mobile.alt')}</VisuallyHidden>
        ),
        logo: <DaDreamupLogoAndTextColoredAndBranded view="light" className={s['logo']} />,
      })}
      description={t('playground.emptyState.dreamup.description.mobile')}
      postfix={
        <div className={s['form']}>
          <LoadableIngressForm />
        </div>
      }
    />
  ) : (
    <PlaygroundEmptyStateDesktop
      logo={<DaDreamupLogoAndTextColoredAndBranded view="light" className={s['logo']} />}
      heading={t('playground.emptyState.dreamup.heading.desktop')}
      description={t('playground.emptyState.dreamup.description.desktop')}
      postfix={
        <div className={s['form']}>
          <LoadableIngressForm />
        </div>
      }
    />
  );
};

DreamupEmptyState.displayName = 'DreamupEmptyState';

export default DreamupEmptyState;
